import template from './notesListItem.template.html';

export default {
  template,
  bindings: {
    note: '=',
    showsInAll: '<',
    isLatest: '<',
    accounts: '=',
    contacts: '<',
    partners: '<',
    labels: '=',
    workflows: '<',
    tickets: '<',
    onEdit: '&',
    onDelete: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onPin: '&',
    onLabelsSelect: '&',
    onPreviewAttachment: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      fileFactory,
      eventService,
      DOCUMENT,
      NOTE,
      FILE
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;
      ctrl.mdMedia = $mdMedia;
      ctrl.isNoteForContact = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat();
        ctrl.contacts = ctrl.contacts ? ctrl.contacts : [];
        ctrl.partners = ctrl.partners ? ctrl.partners : [];
        ctrl.workflows = ctrl.workflows ? ctrl.workflows : [];
        ctrl.tickets = ctrl.tickets ? ctrl.tickets : [];
        ctrl.showActions = ctrl.workflows.length === 0 || ctrl.tickets.length === 0;
        ctrl.showMore = false;
        ctrl.isNoteForContact = ctrl.note.idContact;
        ctrl.acceptableFileExtensions = FILE.ACCEPTABLE_FILE_EXTENSIONS;
        $timeout(() => {
          ctrl.isReady = true;
          ctrl.setHeightOfContent();
          return null;
        });
      };

      ctrl.notePin = ($event, data) => {
        ctrl.onPin({ event: $event, data });
      };

      ctrl.noteShareClient = ($event, data) => {
        ctrl.onShareClient({ event: $event, data });
      };

      ctrl.noteSharePartner = ($event, data) => {
        ctrl.onSharePartner({ event: $event, data });
      };

      ctrl.noteLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.noteEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.noteDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.previewAttachment = ($event, attachment) => {
        eventService.filePreview({
          event: $event,
          file: attachment,
          type: 'notes'
        });
      };

      ctrl.downloadAttachment = (data, noteType) => {
        if (noteType !== 'video') {
          fileFactory
            .getDownloadUrl({ url: NOTE.API.DOWNLOAD, file: data.file, name: data.name })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl);
            });
        } else {
          fileFactory
            .getDownloadVideoUrl({
              url: NOTE.API.DOWNLOAD_VIDEO,
              idAttachment: data.id,
              file: data.file,
              name: data.name
            })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl);
            });
        }
      };

      ctrl.downloadAttachmentPdf = (data, noteType) => {
        if (noteType !== 'video') {
          fileFactory
            .getDownloadUrl({ url: NOTE.API.DOWNLOAD_PDF, file: data.file, name: data.name })
            .then((downloadUrl) => {
              fileFactory.download(downloadUrl, true);
            });
        }
      };

      ctrl.canOpenPreview = (attachment) =>
        _.indexOf(
          ctrl.acceptableFileExtensions || [],
          attachment?.getFileExtension()?.toLowerCase()
        ) > -1;

      ctrl.canEdit = () =>
        moment().diff(moment.utc(ctrl.note.timeStamp, 'X'), 'hours') < 24 ||
        $rootScope.CurrentOrganization.idOwner === $rootScope.CurrentAccount.id;

      ctrl.canDownloadPdf = (attachment) =>
        DOCUMENT.DOWNLOAD_DOCUMENT_AS_PDF.indexOf(attachment.getFileExtension()) > -1;

      ctrl.getAccount = (idAccount) => ctrl.accounts.find((a) => a.id === idAccount);

      ctrl.getContact = (idContact) => ctrl.contacts.find((c) => c.id === idContact);

      ctrl.getPartner = (idPartner) => ctrl.partners.find((p) => p.id === idPartner);

      ctrl.getLabel = (idLabel) => ctrl.labels.find((l) => l.id === idLabel);

      ctrl.getWorkflow = (idWorkflow) => ctrl.workflows.find((w) => w.id === idWorkflow);

      ctrl.getTicket = (idTicket) => ctrl.tickets.find((t) => t.id === idTicket);

      ctrl.getAttributeValue = ({ attribute }) =>
        _.isArray(attribute?.value) ? attribute?.value?.join(', ') : attribute?.value;

      ctrl.toggleShowMore = () => {
        ctrl.showMore = !ctrl.showMore;
        ctrl.setItemHeight();
      };

      ctrl.getHeightOfContent = () => {
        const nHeight = angular.element(document.querySelector(`#n-${ctrl.note.id}`));
        const aHeight = angular.element(document.querySelector(`#a-${ctrl.note.id}`));
        const lHeight = angular.element(document.querySelector(`#l-${ctrl.note.id}`));
        const cHeight =
          ctrl.note?.type?.name === 'email' && ctrl.note?.attributes?.length
            ? _.sum([nHeight[0].scrollHeight, aHeight[0].scrollHeight, 22])
            : nHeight[0].scrollHeight;
        return cHeight > lHeight[0].scrollHeight ? cHeight : lHeight[0].scrollHeight;
      };

      ctrl.setHeightOfContent = () => {
        if (ctrl.isReady) {
          return $timeout(() => {
            const heightOfContent = ctrl.getHeightOfContent();
            ctrl.contentHeight = {
              height: heightOfContent < 105 ? `calc(${heightOfContent}px + 1em)` : '105px'
            };
            const bHeight = _.add(heightOfContent < 105 ? heightOfContent + 24 : 142, 48);
            ctrl.badgeHeight = { height: `${bHeight}px` };
            return {
              height: heightOfContent < 105 ? `${heightOfContent}px` : '105px'
            };
          });
        }
        ctrl.contentHeight = { height: '105px' };
        ctrl.badgeHeight = { height: '216px' };
        return { height: `105px` };
      };

      ctrl.isContentLong = () => (ctrl.isReady ? ctrl.getHeightOfContent() > 105 : false);

      ctrl.isContentShort = () => (ctrl.isReady ? ctrl.getHeightOfContent() < 50 : false);

      ctrl.setItemHeight = () => {
        $timeout(() => {
          const heightOfContent = ctrl.getHeightOfContent();
          if (ctrl.showMore) {
            ctrl.contentHeight = {
              height: `${_.add(heightOfContent, 16)}px`
            };
            ctrl.badgeHeight = {
              height: `${_.add(heightOfContent, 112)}px`
            };
          } else {
            ctrl.contentHeight = {
              height: heightOfContent < 105 ? `calc(${heightOfContent}px + 1em)` : '105px'
            };
            const bHeight = _.add(heightOfContent < 105 ? heightOfContent + 24 : 142, 48);
            ctrl.badgeHeight = { height: `${bHeight}px` };
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.notes && changes.notes.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
